// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"c46f6ed6","990":"5340996e"}[chunkId] + ".chunk.js";
};